import {
  Table as MantineTable,
  type TableProps as MantineTableProps,
  type TableScrollContainerProps as MantineTableScrollContainerProps,
} from '@mantine/core';

export type TableProps = MantineTableProps;
export type TableScrollContainerProps = MantineTableScrollContainerProps;
/** Data table for displaying structured rows and columns with optional striping and hover. */
export const Table = MantineTable;

/** Scrollable container for tables that overflow on small viewports. */
export const TableScrollContainer = MantineTable.ScrollContainer;
/** Table header section containing column headings. */
export const TableThead = MantineTable.Thead;
/** Table body section containing data rows. */
export const TableTbody = MantineTable.Tbody;
/** Table row container. */
export const TableTr = MantineTable.Tr;
/** Table header cell for column labels. */
export const TableTh = MantineTable.Th;
/** Table data cell for row values. */
export const TableTd = MantineTable.Td;
